import axios from "axios";
import { Auth } from "aws-amplify";

/**
 * Intercept all axios request.
 */
// axios.interceptors.request.use(
//   function (config) {
//     config.headers = {
//       ...config.headers,
//       "Content-Type": "application/json",
//     };

//     return config;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

axios.defaults.headers = {
  "Content-Type": "application/json",
};

axios.interceptors.request.use(function (config) {
  return new Promise((resolve) => {
    Auth.currentSession()
      .then((session) => {
        if (config?.isNotAuth) return resolve(config);
        var idTokenExpire = session.getIdToken().getExpiration();
        var refreshToken = session.getRefreshToken();
        var currentTimeSeconds = Math.round(+new Date() / 1000);
        if (idTokenExpire < currentTimeSeconds + 180) {
          Auth.currentAuthenticatedUser().then((res) => {
            res.refreshSession(refreshToken, (err, data) => {
              if (err) {
                Auth.signOut();
              } else {
                config.headers.Authorization = data.getIdToken().getJwtToken();
                resolve(config);
              }
            });
          });
        } else {
          config.headers.Authorization = session.getIdToken().getJwtToken();
          resolve(config);
        }
      })
      .catch(() => {
        const CancelToken = axios.CancelToken;
        // No logged-in user: don't set auth header
        if (config?.isNotAuth) return resolve(config);
        if (config?.isNotCancel) return resolve(config);
        if (config?.isNotCallUnAuth)
          return resolve({
            ...config,
            cancelToken: new CancelToken((cancel) => cancel()),
          });
        Auth.signOut();
        resolve({
          ...config,
          cancelToken: new CancelToken((cancel) => cancel("Cancel repeated request")),
        });
      });
  });
});

/**
 * Intercept all axios response.
 */
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axios;
